<template>
    <div>
        <!-- Show skeleton UI when loading -->
        <div v-if="loading" class="tw-animate-pulse">
            <div class="tw-flex tw-flex-col">
                <div class="tw-h-6 tw-w-32 tw-bg-gray-100 tw-rounded tw-mb-1"></div>
                <div class="tw-h-10 tw-w-full tw-bg-gray-100 tw-rounded"></div>
            </div>
        </div>
        <!-- Show actual content when not loading -->
        <div v-else>
            <FormVueSelect hide-errors multiple :searchable="true" v-model="selectedValues" max-height="200" class="!tw-h-fit"
                :options="options" option-value="id" :label="$t('fields.marketer_id')" :error="errors.marketer_id &&
                    $t('errors.' + errors.marketer_id, {
                        field: $t('fields.marketer_id'),
                    })
                    ">
                <template v-slot:option="{ option }">
                    <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{
                        option.name }}</p>
                </template>
                <template v-slot:selected-option-container="{ params }">
                    <div class="vs__selected tw-text-xs tw-py-0 tw-px-2" @click="removeValue(params.option.id)">{{ params.option.name
                        }}</div>
                </template>
            </FormVueSelect>
        </div>
    </div>
</template>

<script setup>
// import { onClickOutside } from '@vueuse/core';
import { ads } from '@/api/analytics';
import users from '@/api/users';
import FormVueSelect from "@/components/form/FormVueSelect";
import { ref, watch, inject } from 'vue';

// import { useI18n } from "vue-i18n";

// const i18n = useI18n();
const updateFilters = inject('update:filters')
const marketers = ref([]);
const filters = inject('filters')
const options = ref([])
const loading = ref(false);

const errors = ref({})
const selectedValues = ref(filters.value.marketer_id ?? []);
watch(() => selectedValues.value, () => {
    const newFilters = {
        ...filters.value,
        marketer_id: selectedValues.value,
    }

    updateFilters(newFilters)
})



const removeValue = value => {
    
    selectedValues.value = selectedValues.value.filter(v => v != value)
}

const getOptions = async () => {
    loading.value = true;
    await users.byRoles(['marketer'], { all: true})
    .then(
        res => {
            if(res.data.code == 'SUCCESS') {
                options.value = res.data.users
                options.value.map(c => marketers.value[c.id] = c.name)
            }
        }
    )
    loading.value = false;
}

const getAdsData = async () => {
    loading.value = true;
    await ads(filters.value)
    .then(
        res => {
            console.log(res.data)
        }
    )
    .catch(
        err => {
            console.log(err)
        }
    )
    loading.value = false;
}
getOptions()
getAdsData()
</script>

<style></style>